/*
 * @Author: LiuShiNeng undefined
 * @Date: 2023-04-20 16:39:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-09 08:52:29
 * @FilePath: /web-register/src/main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
// import '@plus/util/dist/changeDocsUrl'
import Vue from 'vue'
// import VueCompositionAPI from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { message } from 'ant-design-vue'
import dw from '@src/plugins/direct-stat'
import initLogic from '@quick/flow'
import mainModule from './mainModule'
import pkg from "../package.json";
import i18n from '@src/i18n'
//全局挂载跳转
import { ConditionalJumpLink, setAppVersionInWindow, isMobile } from '@src/util'
// import '@assets/reset.scss'

// #690 分享信息原则通过window.wps.showShareMenu传递，不确定客户端再什么情况下会回调下面4个方法导致异常
// 先补充空方法，后续找客户端同学确认
window.share_des = () => {}
window.share_icon = () => {}
window.share_url = () => {}
window.share_title = () => {}
window._store = store

// Vue.use(VueCompositionAPI)
Vue.prototype.$report = dw
Vue.prototype.$message = message

//实现不用存储在store的跨组件数据传递
Vue.prototype.$eventHub = new Vue()

Vue.prototype.$Jump = ConditionalJumpLink
Vue.config.productionTip = false

// 设置appInfo
setAppVersionInWindow()
const tag = isMobile() ? 'mobile' : 'PC'
window.APM?.init({
  // 应用ID，必填
  appId: 'vNe6vS7Z',
  // 业务名称，必填
  appName: `${import.meta.env.VITE_APP_KAE_ENVIRONMENT}_${tag}_web-register`,
  // 业务版本号
  appVersion: pkg.version,
  // 采样率
  samplingRate: 1,
  // 插件名称 @todo 端内插件场景下需要填写
  // pluginName: 'xxx-plugin',
  // 是否开启debug模式，是则在控制台输出日志
  isDebug: false,
  // 用户userId @todo 如刚引入无法提供userID，可见下述方式处理
  // accountId: 'xxxx',
  // 插件配置 - 开关策略、采样率
  pluginConfig: {
    // 性能插件配置
    performance: { switch: true },
    // 业务日志插件配置
    businessLogger: { switch: true },
    // vue框架错误捕获插件
    vue: { switch: true, vue: window.Vue },
    // js异常错误捕获插件
    windowOnError: { switch: true },
    // web资源异常捕获插件
    windowSourceError: { switch: true },
    // promise异常捕获插件
    windowUnhandledRejection: { switch: true },
    // 资源慢加载捕获插件
    source: {
      switch: true,
      threshold: 3000,
      ignoreUrls: [],
    },
    // 请求捕获插件
    request: {
      switch: true,
      threshold: 3000,
      ignoreUrls: [],
    },
  },
})

// 测试dw包，测试完删除
if (sessionStorage.getItem('dwTest')) {
  dw.report('enterprise_signuppage', {
    operate: 'before_show',
  })
  sessionStorage.removeItem('dwTest')
}

function vueInstantiation() {
  const _vue = new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  })

  return _vue
}

window.logic = initLogic({
  mode: import.meta.env.VITE_FLOW_MODE,
})

if (window?.$initRouteVueMode) {
  const _vue = vueInstantiation()
  Vue.prototype.$initRouteVueMode = true
  // Vue.prototype.$regPlatformTargetPage = 'SignUp'
  _vue.$mount('#register-app')
} else {
  window.InitRegisterPlatform = mainModule
}

export default mainModule
